export enum PlatformEnum {
  APP_IOS = 'APP_IOS',
  APP_ANDROID = 'APP_ANDROID',
  WEB = 'WEB',
}
export interface PlatformContextConfig {
  platform: PlatformEnum;
  paymentEmitterPlatform?: PlatformEnum;
}
